.wrapper {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.95);
  border-bottom: 1px solid var(--common-gray-3);
}

@screen phone {
  .wrapper {
    position: absolute;
    border-bottom: none;
    background-color: transparent;
    padding: 0 1rem;
  }
}
